import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import NoticesList from './NoticesList';
import NoticeCreate from './NoticeCreate';
import NoticeEdit from './NoticeEdit';
import NoticeView from './NoticeView';
import NoticeAreas from './NoticeAreas';
import SupplierNotices from './SupplierNotices';
import SupplierNoticeCreate from './SupplierNoticeCreate';
import SupplierNoticeEdit from './SupplierNoticeEdit';
import SupplierNoticeView from './SupplierNoticeView';

function Notices() {
  return (
    <Routes>
      <Route index element={<NoticesList />} />
      <Route path="create" element={<NoticeCreate />} />
      {/* Supplier routes - support both singular and plural */}
      <Route path="supplier" element={<SupplierNotices />} />
      <Route path="suppliers" element={<SupplierNotices />} />
      <Route path="supplier/create" element={<SupplierNoticeCreate />} />
      <Route path="supplier/view/:noticeId" element={<SupplierNoticeView />} />
      <Route path="supplier/edit/:noticeId" element={<SupplierNoticeEdit />} />
      {/* Areas management route */}
      <Route path="areas/:noticeId" element={<NoticeAreas />} />
      {/* Generic notice routes - must be last to avoid matching other routes */}
      <Route path=":noticeId" element={<NoticeView />} />
      <Route path=":noticeId/edit" element={<NoticeEdit />} />
    </Routes>
  );
}

export default Notices; 